import { Fragment } from "react";

const TitleOfPage = (props) => {
  return (
    <Fragment>
      <div className="row">
        <div className="col-lg-11 padding3px">
          <div className="card padding5 margin0">
            <div className="card-body padding0 ">
              <div
                style={{
                  fontSize: "18px",
                  color: "blue",
                  fontWeight: "bolder",
                }}
              >
                {props.title}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default TitleOfPage;
